export default __webpack_public_path__ + "static/media/stampBanner.403b4b9b.jpg";